import React, { useState, useEffect } from 'react';
import { withTranslation } from './ChildrenContext.js';
import PropTypes from 'prop-types';
import { I18nFormatter } from '../utils/I18n/I18n';

const Timer = ({ time = 0, onStop, t }) => {
    const [seconds, setSeconds] = useState(time);
    const [format, setFormat] = useState(I18nFormatter.duration(time));

    useEffect(() => {
        setSeconds(time);
        setFormat(I18nFormatter.duration(time));
    }, [time]);

    useEffect(() => {
        if (time <= 0) {
            if (time === 0) {
                setFormat(I18nFormatter.duration(0));
            }
            return;
        }

        const interval = setInterval(() => {
            setSeconds(prevSeconds => {
                if (prevSeconds <= 1) {
                    clearInterval(interval);
                    onStop && onStop();
                    setFormat(I18nFormatter.duration(0));
                    return 0;
                }

                const nextSeconds = prevSeconds - 1;
                setFormat(I18nFormatter.duration(nextSeconds));
                return nextSeconds;
            });
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [time, onStop]);

    return (
        <span>{format}</span>
    );
};

Timer.propTypes = {
    time: PropTypes.number,
    onStop: PropTypes.func,
    t: PropTypes.object
};

export default withTranslation(Timer);
